import { render, staticRenderFns } from "./manage-pictogram-add.vue?vue&type=template&id=62d68454&scoped=true"
import script from "./manage-pictogram-add.vue?vue&type=script&lang=js"
export * from "./manage-pictogram-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d68454",
  null
  
)

export default component.exports